export function normalizeHeading(deg: number): number {
  return ((deg % 360) + 360) % 360;
}

export function rotationCoverScale(deg: number): number {
  const theta = (normalizeHeading(deg) * Math.PI) / 180;
  return Math.abs(Math.cos(theta)) + Math.abs(Math.sin(theta));
}

export function unrotatePanDelta(
  dx: number,
  dy: number,
  heading: number
): { x: number; y: number } {
  const normalized = normalizeHeading(heading);
  const cover = rotationCoverScale(normalized);
  const theta = (normalized * Math.PI) / 180;
  const cos = Math.cos(theta);
  const sin = Math.sin(theta);
  return {
    x: (dx * cos + dy * sin) / cover,
    y: (-dx * sin + dy * cos) / cover
  };
}
